export const selectToken = (state) => state.user.token

export const selectUser = (state) => state.user

export const selectEmail = (state) => state.user.email

export const selectId = state => state.user.id